module.exports = __webpack_public_path__ + "static/media/devis-credit.d7cb4f08.webp";